import './resumo-estatisticas.css';
import api from '../../services/cle';
import 'react-tabs/style/react-tabs.css';
import { useState, useEffect } from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { useAppSelector } from '../../store/hooks';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Button from '../../rxlib/components/buttons/button';
import InputLabel from '../../rxlib/components/input-label';
import { ApiError, LegendaOrigem } from '../../services/tipos';
import { Listagem } from '../../rxlib/components/layout/listagem';
import { ConfiguracoesTabela } from '../../rxlib/components/table';
import { usuarioTemPermissao } from '../../rxlib/services/seguranca';
import AcessoBloqueado from '../../rxlib/components/acesso-bloqueado';
import { RxlibLayout } from '../../rxlib/components/layout/rxlib-Layout';
import { SelectLabel } from '../../rxlib/components/select/select-label';
import { ModalWarning } from '../../rxlib/components/modal/modal-warning';
import Breadcrumb, { BreadcrumbItem } from '../../rxlib/components/breadcrumb';
import { formatarData, obterDataAtual, tratarErroApi } from '../../rxlib/services/utilitarios';

interface Filtros {
    origem: string;
    tipoData: string;
    dataFinal: string;
    dataInicial: string;
}

type Dado = { [key: string]: string; };

interface Aba {
    aba: string;
    dados: [Dado];
    campos: ConfiguracoesTabela,
}

function EstatisticasListagem() {
    const [itensOrigem, setItensOrigem] = useState<any>([]);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [legendasOrigem, setLegendasOrigem] = useState<LegendaOrigem[]>([]);

    const dataAtualstring = obterDataAtual();
    const temPermissao = usuarioTemPermissao(token, 'resumo_estatisticas_consulta');

    const [filtros, setFiltros] = useState<Filtros>({
        origem: 'SEL',
        tipoData: '0',
        dataFinal: dataAtualstring,
        dataInicial: dataAtualstring,
    });

    const [abasOrigens, setAbasOrigens] = useState<Aba[]>([{
        aba: '',
        campos: {
            mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
            colunas: [],
        },
        dados: [{
        }],
    }]);

    const { register, handleSubmit } = useForm<Filtros>();

    const handleHide = () => setShowWarning(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Consulta do resumo das estatísticas', link: '' },
    ];

    const itensTipoData: any = [
        { id: 0, nome: 'Referência' },
        { id: 1, nome: 'Recebimento' },
    ];

    useEffect(() => {
        api.get('/LegendaOrigem/')
            .then((response: AxiosResponse<any>) => {
                setLegendasOrigem(response.data);

                const itensOrigem: any = [
                    {
                        id: 'SEL',
                        nome: 'Selecione'
                    },
                    {
                        id: 'ONI',
                        nome: 'Origem não identificada',
                    }
                ];

                for (let index = 0; index < response.data.length; index++) {
                    itensOrigem.push({
                        id: response.data[index].origem,
                        nome: getLegendaOrigem(response.data, response.data[index].origem),
                    });
                }

                setItensOrigem(itensOrigem);
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
    }, []);

    useEffect(() => {
        if ((temPermissao) && (filtros.tipoData) && (filtros.dataInicial) && (filtros.dataFinal)) {
            setCarregando(true);
            api.get(getUrlConsulta())
                .then((response: AxiosResponse<any>) => {
                    let abas: Aba[] = [{
                        aba: '',
                        campos: {
                            mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
                            colunas: [],
                        },
                        dados: [{
                        }],
                    }];

                    setTimeout(() => {
                        carregarAbas(abas, response);
                        carregarDados(abas, response);
                        setAbasOrigens(abas);
                        setCarregando(false);
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                    setShowWarning(true);
                });
        }

        function carregarAbas(abas: Aba[], response: AxiosResponse<any>) {
            if (response.data.value.length > 0) {
                for (let indice: number = 0; indice < response.data.value.length; indice++) {
                    const legenda: string = getLegendaOrigem(legendasOrigem, response.data.value[indice].Origem);

                    if (abas.find(item => item.aba === legenda) === undefined) {
                        if (indice === 0) {
                            abas[0].aba = legenda;
                        } else {
                            abas.push({
                                aba: legenda,
                                campos: {
                                    mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
                                    colunas: [],
                                },
                                dados: [{
                                }],
                            });
                        }
                    }
                }
            }
        }

        function carregarDados(abas: Aba[], response: AxiosResponse<any>) {
            if (response.data.value.length > 0) {
                for (let indice: number = 0; indice < response.data.value.length; indice++) {
                    let dados: any = JSON.parse(response.data.value[indice].Dados.replaceAll("'", '"')).Estatisticas;

                    dados['DataReferencia'] = formatarData(response.data.value[indice].DataReferencia);
                    dados['Quantidade'] = 1;

                    let legenda: string = getLegendaOrigem(legendasOrigem, response.data.value[indice].Origem);

                    for (let indiceAba: number = 0; indiceAba < abas.length; indiceAba++) {
                        if (abas[indiceAba].aba === legenda) {
                            carregarDadosLinha(abas, indiceAba, dados);
                            carregarCampos(abas, indiceAba, dados);
                            break;
                        }
                    }
                }
            }
        }

        function carregarDadosLinha(abas: Aba[], indiceAba: number, dados: any) {
            if ((abas[indiceAba].dados.length > 0) && (abas[indiceAba].dados[0]['DataReferencia'] === undefined)) {
                abas[indiceAba].dados[0] = dados;
            } else {
                let item: Dado | undefined = abas[indiceAba].dados.find(item => item['DataReferencia'] === dados['DataReferencia']);
                if (item !== undefined) {
                    item['Quantidade'] = String(Number(item['Quantidade']) + Number(dados['Quantidade']));

                    let campos = Object.getOwnPropertyNames(dados);
                    for (let indiceCampos = 0; indiceCampos < campos.length; indiceCampos++) {
                        if ((campos[indiceCampos] !== 'DataReferencia') && (campos[indiceCampos] !== 'Quantidade')) {
                            item[campos[indiceCampos]] = String(Number(item[campos[indiceCampos]]) + Number(dados[campos[indiceCampos]]));
                        }
                    }
                } else {
                    abas[indiceAba].dados.push(dados);
                }
            }
        }

        function carregarCampos(abas: Aba[], indiceAba: number, dados: any) {
            if ((!abas[indiceAba].campos.colunas.find(campo => campo.nome === 'DataReferencia'))) {
                abas[indiceAba].campos.colunas.push({ nome: 'DataReferencia', campo: 'DataReferencia', tipo: 'string' });
            }

            if ((!abas[indiceAba].campos.colunas.find(campo => campo.nome === 'Quantidade'))) {
                abas[indiceAba].campos.colunas.push({ nome: 'Quantidade', campo: 'Quantidade', tipo: 'string' });
            }

            let campos = Object.getOwnPropertyNames(dados);
            for (let indiceCampos = 0; indiceCampos < campos.length; indiceCampos++) {
                if ((!abas[indiceAba].campos.colunas.find(campo => campo.nome === campos[indiceCampos]))) {
                    abas[indiceAba].campos.colunas.push({ nome: campos[indiceCampos], campo: campos[indiceCampos], tipo: 'string' })
                }
            }
        }

        function getUrlConsulta(): string {
            let url: string = `OData/Estatisticas?$filter=`;

            switch (filtros.tipoData) {
                case '0':
                    url += `date(dataReferencia) ge ${filtros.dataInicial} and date(dataReferencia) le ${filtros.dataFinal}`;
                    break;
                case '1':
                    url += `date(data) ge ${filtros.dataInicial} and date(data) le ${filtros.dataFinal}`;
                    break;
            }

            if (filtros.origem !== 'SEL') {
                if (filtros.origem === 'ONI') {
                    url += ' and origem eq \'\' ';
                } else {
                    url += ` and origem eq '${filtros.origem}'`;
                }
            }

            return url;
        }
    }, [temPermissao, filtros, legendasOrigem]);

    function getLegendaOrigem(legendasOrigem: LegendaOrigem[], origem: string): string {
        let legenda: string = '';

        if (legendasOrigem) {
            const legendaOrigem: LegendaOrigem | undefined = legendasOrigem.find(item => item.origem === origem);
            if (legendaOrigem) {
                legenda = legendaOrigem.legenda;
            }
        }

        if (legenda === '') {
            legenda = 'Origem não identificada';

            if (origem !== '') {
                legenda += ' (' + origem + ')';
            }
        }

        return legenda;
    }

    const onSubmit: SubmitHandler<Filtros> = data => {
        const dataFinal = new Date(data.dataFinal);
        const dataInicial = new Date(data.dataInicial);

        if ((data.tipoData === '1') && (dataInicial.getTime() > dataFinal.getTime())) {
            setMessageWarning(['Data inicial maior que a data final de recebimento.']);
            setShowWarning(true);
        } else if ((data.tipoData === '0') && (dataInicial.getTime() > dataFinal.getTime())) {
            setMessageWarning(['Data inicial maior que a data final de referência.']);
            setShowWarning(true);
        } else {
            setFiltros({
                origem: data.origem,
                tipoData: data.tipoData,
                dataFinal: data.dataFinal,
                dataInicial: data.dataInicial,
            });
        }
    }

    function tratarErro(error: AxiosError<ApiError>) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
        setShowWarning(true);
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <form onSubmit={handleSubmit(onSubmit)} className='mb-1'>
                    <div className='container-fluid'>
                        <div className='row px-1'>
                            <div className='col-2'>
                                <SelectLabel
                                    action=''
                                    foco='sim'
                                    name='origem'
                                    required='nao'
                                    label='Origem:'
                                    id='inputOrigem'
                                    ariaLabel='origem'
                                    valorSelecionado=''
                                    itens={itensOrigem}
                                    campoExibicaoRegistro='nome'
                                    campoIdentificadorRegistro='id'
                                    className='rxlib-select-label-coluna'
                                    referencia={register({ required: false })} />
                            </div>
                            <div className='col-2'>
                                <SelectLabel
                                    action=''
                                    foco='nao'
                                    label='Data:'
                                    name='tipoData'
                                    id='inputTipoData'
                                    ariaLabel='tipoData'
                                    itens={itensTipoData}
                                    valorSelecionado={'0'}
                                    campoExibicaoRegistro='nome'
                                    campoIdentificadorRegistro='id'
                                    className='rxlib-select-label-coluna'
                                    referencia={register({ required: true })} />
                            </div>
                            <div className='col-8' />
                        </div>
                        <div className='row px-1 mt-2'>
                            <div className='col-2'>
                                <InputLabel
                                    type='date'
                                    maxLength={10}
                                    readOnly={false}
                                    id='dataInicial'
                                    autoFocus={false}
                                    name='dataInicial'
                                    label='Data inicial:'
                                    placeholder='  /  /    '
                                    defaultValue={dataAtualstring}
                                    className='rxlib-input-label-coluna'
                                    referencia={register({ required: true })} />
                            </div>
                            <div className='col-2'>
                                <InputLabel
                                    type='date'
                                    maxLength={10}
                                    id='dataFinal'
                                    readOnly={false}
                                    name='dataFinal'
                                    autoFocus={false}
                                    label='Data final:'
                                    placeholder='  /  /    '
                                    defaultValue={dataAtualstring}
                                    className='rxlib-input-label-coluna'
                                    referencia={register({ required: true })} />
                            </div>
                            <div className='col-2 rxlib-celula-botao'>
                                <Button
                                    type='submit'
                                    texto='Consultar'
                                    classStyle='btn-rxlib' />
                            </div>
                            <div className='col-6'>
                            </div>
                        </div>
                    </div>
                </form>
                <div className='container-fluid mb-5 mt-1'>
                    {
                        ((abasOrigens.length > 0) && (abasOrigens[0].aba !== ''))
                            ? <div className='row px-1 mt-3'>
                                <Tabs>
                                    <TabList>
                                        {
                                            abasOrigens.map((item, index) =>
                                                <Tab id={String(index)}>{item.aba}</Tab>
                                            )
                                        }
                                    </TabList>
                                    {
                                        abasOrigens.map((item, index) =>
                                            <TabPanel id={String(index)}>
                                                <Listagem
                                                    tipoBotaoAcao='button'
                                                    listagemDetalhe={false}
                                                    carregando={carregando}
                                                    fonteDados={item.dados}
                                                    campoId='DataReferencia'
                                                    className='resumo-estatisticas-listagem'
                                                    configuracoesTabela={item.campos} />
                                            </TabPanel>
                                        )
                                    }
                                </Tabs>
                            </div>
                            : <div className='row px-3'>
                                <table className='table table-striped rxlib-table-overflow'>
                                    <thead>
                                        <tr>
                                            <th scope='col'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Não foram encontrados resultados para a consulta.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    }
                </div>
                <ModalWarning
                    show={showWarning}
                    onHide={handleHide}
                    message={messageWarning} />
                <AcessoBloqueado
                    permissao={temPermissao} />
            </RxlibLayout>
        </>
    );
}

export default EstatisticasListagem;